module.exports = __webpack_public_path__ + "static/media/21.e638befd.png";